export default __webpack_public_path__ + "static/media/YouTube.d7e12dcc.svg";